function extractTextFromHTML(htmlContent) {
    // Replace any tag that is not <br>, <b>, <strong>, <i>, <em>, or <a> (or their closing tags) with a space.
    let result = htmlContent
        .replace(/<(?!\/?(?:br|b|strong|i|em|a)\b)[^>]+>/gi, ' ') // Preserves allowed tags including <a>
        .replace(/\s+/g, ' ') // Remove excessive spaces
        .trim();

    // Convert <em> tags to underlined spans
    result = result.replace(/<em\b([^>]*)>(.*?)<\/em>/gi, '<span class="richtext_transform-underline">$2</span>');

    // Check if the text contains the ™ symbol and wrap it with a span to apply specific font-family.
    if (result.includes('™')) {
        result = result.replace(/™/g, '<span class="text-tm" style="font-family: \'DM Sans\'; display: inline">™</span>');
    }

    // Ensure that every <a> tag has underline decoration.
    result = result.replace(/<a\b([^>]*)>/gi, function (fullMatch, attributes) {
        if (/style\s*="/i.test(attributes)) {
            // If there is already a style attribute, append the underline rule if it's not already present.
            return fullMatch.replace(/style="([^"]*)"/i, function (styleMatch, styleValue) {
                if (styleValue.includes('text-decoration: underline')) {
                    return styleMatch; // already styled as needed
                }
                let newStyle = styleValue.trim();
                // Ensure there is a trailing semicolon if needed.
                if (newStyle && newStyle.slice(-1) !== ';') {
                    newStyle += ';';
                }
                newStyle += ' text-decoration: underline;';
                return `style="${newStyle}"`;
            });
        } else {
            // No style attribute found: insert one with text-decoration: underline.
            // Note the extra space before existing attributes for proper formatting.
            return `<a style="text-decoration: underline;"${attributes ? ' ' + attributes : ''}>`;
        }
    });

    return result;
}

function transformRichTextElements() {
    document.querySelectorAll('.richtext_transform').forEach((element) => {
        element.innerHTML = extractTextFromHTML(element.innerHTML);
    });
}

// Run the transformation on page load.
document.addEventListener('DOMContentLoaded', transformRichTextElements);
